<div>
  @if (!imageData.image) {
    <div
      [ngClass]="imageData.class"
      [class.add-image]="!imageData?.title && !imageData.id"
      class="circle-image-box position-relative font-weight-normal d-flex justify-content-center align-items-center"
      [style.width]="imageData?.radius||''"
      [style.height]="imageData?.radius||''"
      [style.background-color]="(imageData.id||imageData.title)|nameToColor">
      {{ imageData.title?.charAt(0).toUpperCase()  || '270x270'}}
    </div>
  } @else {
    <img [src]="imageData.image"
      [ngClass]="imageData.class"
      [style.width]="imageData?.radius||''"
      [style.height]="imageData?.radius||''"
      class="circle-image-box"
      [alt]="imageData.title"/>
    }
    @if (imageData.isCaptain) {
      <div class="capitan-icon d-flex position-relative justify-content-center align-items-center"
        >
        <span class="icon-wheel"></span>
      </div>
    }
  </div>
